// ** Initial State
const initialState = {
  allAdvertisement: [],
  advertisement: null,
}

const advertisement = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_ADVERTISEMENT':
      return { ...state, allAdvertisement: action.data }
    case 'GET_DATA':
      return { ...state, advertisement: action.data }
    default:
      return { ...state }
  }
}
export default advertisement
